module.exports = __webpack_public_path__ + "fonts/iconfont.9ad1ec80.woff";